import {
  CLEAN_PDF,
  GET_PAYMENT_PDF_LINK,
  CLEAR_FORM
} from '../actions';

const iniState = {
  pdfData: null,
  pdfFailed: false,
  pdfLoading: false,
  pdfSucceeded: false
};

export default (state = iniState, action) => {
  switch (action.type) {
    case CLEAN_PDF:
      return {
        pdfData: null,
        pdfFailed: false,
        pdfLoading: false,
        pdfSucceeded: false
      };
    case `${GET_PAYMENT_PDF_LINK}_PENDING`:
      return {
        ...state,
        pdfData: null,
        pdfLoading: true,
        pdfFailed: false,
        pdfSucceeded: false
      };
    case `${GET_PAYMENT_PDF_LINK}_REJECTED`:
      return {
        ...state,
        pdfData: action.payload ? action.payload.data : null,
        pdfLoading: false,
        pdfFailed: true,
        pdfSucceeded: false
      };
    case `${GET_PAYMENT_PDF_LINK}_FULFILLED`:
      return {
        ...state,
        pdfData: action.payload ? action.payload.data : null,
        pdfLoading: false,
        pdfFailed: false,
        pdfSucceeded: true
      };
    case CLEAR_FORM:
      return {
        ...iniState,
      };
    default:
      return state

  }
};